import React from "react";
import { Link, Image, LinkBox, Button, Box, Section } from "@quarkly/widgets";
import { Override } from "@quarkly/components";
import * as Components from "components";
import { FiMenu } from "react-icons/fi";

const CustomHeader = ({ image_logo }) => (
  <>
    <Section quarkly-title="Header" padding="44px 0 44px 0">
      <Override
        slot="SectionContent"
        flex-direction="row"
        justify-content="space-between"
      />
      <LinkBox align-items="flex-start" href="/index">
        <Image
          src={image_logo}
          width="192px"
          height="auto"
          lg-max-width="150px"
          srcSet={`${image_logo} 500w, ${image_logo} 800w, ${image_logo} 1080w, ${image_logo} 1600w, ${image_logo} 2000w, ${image_logo} 2600w, ${image_logo} 3200w`}
          sizes="(max-width: 576px) 100vw, (max-width: 768px) 100vw, (max-width: 992px) 100vw, 100vw"
        />
      </LinkBox>
      <Components.QuarklycommunityKitMobileSidePanel>
        <Override
          slot="Content"
          background="rgba(255, 255, 255, 0)"
          padding="0px 0px 0px 0px"
          md-background="--color-dark"
        />
        <Override slot="Button Icon" md-color="--green" />
        <Override slot="Button Text" md-display="none" />
        <Override slot="Button Icon :closed" category="fi" icon={FiMenu} />
        <Override slot="Cross" md-color="--light" />
        <Box
          md-justify-content="center"
          md-padding="30px 0px 30px 0px"
          display="flex"
          justify-content="flex-end"
          md-align-items="center"
          md-flex-direction="column"
          flex-direction="row-reverse"
        >
          <Button
            color="--light"
            padding="12px 36px 12px 36px"
            background="linear-gradient(180deg,--color-green 0%,#1e1616 100%) 0 0 no-repeat"
            border-radius="32px"
            type="link"
            text-decoration-line="initial"
            target="_blank"
            href="https://alberta.campuslabs.ca/engage/organization/red"
          >
            Join our club on Bearsden
          </Button>
          <Link
            border-style="solid"
            text-decoration-line="initial"
            padding="6px 0px 6px 0px"
            hover-color="--green"
            lg-margin="0px 16px 0px 0px"
            color="--light"
            hover-border-color="--color-green"
            border-width="1px 0px 0px 0px"
            href="/datadashboard"
            transition="color 0.3s --transitionTimingFunction-easeInOut 0s"
            border-color="rgba(255, 255, 255, 0)"
            font="--base"
            margin="0px 72px 0px 16px"
            md-margin="0px 0px 7px 0px"
          >
            Data Dashboard
          </Link>
          <Link
            border-style="solid"
            text-decoration-line="initial"
            padding="6px 0px 6px 0px"
            hover-color="--green"
            lg-margin="0px 16px 0px 0px"
            color="--light"
            hover-border-color="--color-green"
            border-width="1px 0px 0px 0px"
            href="/team"
            transition="color 0.3s --transitionTimingFunction-easeInOut 0s"
            border-color="rgba(255, 255, 255, 0)"
            font="--base"
            margin="0px 16px 0px 16px"
            md-margin="0px 0px 7px 0px"
          >
            Team
          </Link>
          <Link
            border-style="solid"
            text-decoration-line="initial"
            padding="6px 0px 6px 0px"
            hover-color="--green"
            lg-margin="0px 16px 0px 0px"
            color="--light"
            hover-border-color="--color-green"
            border-width="1px 0px 0px 0px"
            href="/articles"
            transition="color 0.3s --transitionTimingFunction-easeInOut 0s"
            border-color="rgba(255, 255, 255, 0)"
            font="--base"
            margin="0px 16px 0px 16px"
            md-margin="0px 0px 7px 0px"
          >
            Articles
          </Link>
          <Link
            border-style="solid"
            text-decoration-line="initial"
            padding="6px 0px 6px 0px"
            hover-color="--green"
            lg-margin="0px 16px 0px 0px"
            color="--light"
            hover-border-color="--color-green"
            border-width="1px 0px 0px 0px"
            href="/projects"
            transition="color 0.3s --transitionTimingFunction-easeInOut 0s"
            border-color="rgba(255, 255, 255, 0)"
            font="--base"
            margin="0px 16px 0px 16px"
            md-margin="0px 0px 7px 0px"
          >
            Projects
          </Link>
          <Link
            transition="color 0.3s --transitionTimingFunction-easeInOut 0s"
            padding="6px 0px 6px 0px"
            margin="0px 16px 0px 16px"
            text-decoration-line="initial"
            hover-border-color="--color-green"
            border-style="solid"
            href="/history"
            color="--light"
            border-width="1px 0px 0px 0px"
            lg-margin="0px 16px 0px 0px"
            md-margin="0px 0px 7px 0px"
            font="--base"
            hover-color="--green"
            border-color="rgba(255, 255, 255, 0)"
          >
            History
          </Link>
          <Link
            padding="6px 0px 6px 0px"
            margin="0px 16px 0px 72px"
            hover-color="--green"
            transition="color 0.3s --transitionTimingFunction-easeInOut 0s"
            hover-border-color="--color-green"
            border-width="1px 0px 0px 0px"
            href="/index"
            color="--light"
            border-color="rgba(255, 255, 255, 0)"
            border-style="solid"
            lg-margin="0px 16px 0px 0px"
            text-decoration-line="initial"
            font="--base"
          >
            Homepage
          </Link>
        </Box>
      </Components.QuarklycommunityKitMobileSidePanel>
    </Section>
  </>
);

export default CustomHeader;
